/****************************************************
 * Module Name:  pendingReportReceivedReport.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React from "react";
import PendingReport from "../common/pendingReportComponent";
import { Box } from "@mui/material";
import NoPermission from "../common/noPermission";
import Constants from "../../utility/constants";
import { useEffect } from "react";
import { useState } from "react";

const PendingReportReceived = () => {
  const [access, setAccess] = useState(false);

  useEffect(() => {
    checkPermission();
  }, []);

  const checkPermission = () => {
    let allowed = Constants.USER_PERMISSION.find(
      (iPermission) =>
        iPermission.permissionid ===
        Constants.PERMISSIONS.REPORT_LABTEST_PENDINGREPORTRECEIVE
    ) !== undefined
    if (!allowed) {
      setAccess(true)
      return <NoPermission />
    }
  }

  return (
    <Box>
      {
        access ? <NoPermission /> : (
          <PendingReport status={"SENT"} name='Report' />
        )}
    </Box>
  );
};

export default PendingReportReceived;
